export function submitUpdatePayerInfo(){
  return (dispatch, getState) => {
    const { organization, resident, paymentSources } = getState()
    const { email, payer_name } = paymentSources
    dispatch({type:'BEGIN_SUBMIT_UPDATE_EMAIL'})
    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}.json`,
      method: 'patch',
      data: {
        resident: {
          payment_payer_email: email.trim(),
          payment_payer: payer_name,
        }
      },
      success: () => {
        dispatch(fetchPaymentSources())
        dispatch({type:'SUCCESS_SUBMIT_UPDATE_EMAIL'})
      },
      error: xhr => {
        const errors = $.parseJSON(xhr.responseText).errors
        dispatch({type: 'FAILED_SUBMIT_UPDATE_EMAIL', payload: errors})
      }
    })
  }
}

export const fetchPaymentSources = () => {
  return(dispatch, getState) => {
    const { organization, resident } = getState()
    
    dispatch({type: 'BEGIN_FETCH_PAYMENT_SOURCES'})
    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources.json`,
      success: (response) => {
        dispatch({ type: 'SUCCESS_FETCH_PAYMENT_SOURCES', payload: response })
      },
      error: xhr => {
        const errors = $.parseJSON(xhr.responseText).errors
        dispatch({ type: 'FAILED_FETCH_PAYMENT_SOURCES', payload: errors })
      }
    });
  }
}

export function deletePaymentSource(payment_source){
  return(dispatch, getState) => {
    const { organization, resident } = getState()

    dispatch({type: 'BEGIN_DESTROY_PAYMENT_SOURCE'})
    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources/${payment_source.id}.json`,
      method: 'DELETE',
      success: () => {
        dispatch({ type: 'SUCCESS_DESTROY_PAYMENT_SOURCE' })
        dispatch(fetchPaymentSources())
      },
      error: xhr => {
        const errors = $.parseJSON(xhr.responseText).errors
        dispatch({ type: 'FAILED_DESTROY_PAYMENT_SOURCE', payload: errors })
      }
    })      
  }
}